import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    @observable welcomeMessage;

    welcomeMessage = 'Please tell Customer Representative there was an "Error starting connection service".';

    loggingService(obj) {
        axios.post(utils.getUrl('loggingService'), {
            errors: obj
        });
    }
}
var WelcomeStore = new store;
export default WelcomeStore;


// WEBPACK FOOTER //
// ./src/js/stores/WelcomeStore.js